import { SimplePageLayout, SimplePageContentWrapper } from '@flexinet/ui-components';
import { ContactsPageHeader } from '../components/PageHeaders';
import { ContactsPageNavigation } from '../navigation/PageNavigations';
import { ContactsTable } from '../tables/ContactsTable';

export const ContactsOverviewPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<ContactsPageHeader />}
            pageNavigation={<ContactsPageNavigation />}
        >
            <SimplePageContentWrapper>
                <ContactsTable />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
